module.exports = __webpack_public_path__ + "img/BT.09afb440.svg";